var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSectionImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 233,
    viewBox: "0 0 209 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.688 233.146C47.1091 233.146 0.5 186.479 0.5 128.957L208.935 128.957C208.877 186.479 162.268 233.146 104.688 233.146Z",
    fill: "#AA468F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.689 128.957C57.6152 128.957 19.4805 90.8226 19.4805 43.7491L189.955 43.7491C189.897 90.7645 151.762 128.957 104.689 128.957Z",
    fill: "#FFA7D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.688 43.6911C68.0045 43.6911 38.2861 13.9728 38.2861 -22.7108L171.148 -22.7108C171.09 13.9728 141.372 43.6911 104.688 43.6911Z",
    fill: "#B687FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionImg);
export default __webpack_public_path__ + "static/media/sectionImg.39325c8c939b61aac688d3585d4f3969.svg";
export { ForwardRef as ReactComponent };